// importing constants
import moreArrow from '../../../constants/moreArrow.js'
import headingPart from '../../../constants/headingPart.js'

// importing helper components
import HeadingPart from '../../Helper/HeadingPart'
import MoreArrow from '../../Helper/MoreArrow'

// importing assets
import project1 from '../../../assets/images/Home/ThingsWeHaveDone/poject1.png'
import project2 from '../../../assets/images/Home/ThingsWeHaveDone/project2.png'
import project3 from '../../../assets/images/Home/ThingsWeHaveDone/project3.png'
import project4 from '../../../assets/images/Home/ThingsWeHaveDone/project4.png'
import project5 from '../../../assets/images/Home/ThingsWeHaveDone/project5.png'
import project6 from '../../../assets/images/Home/ThingsWeHaveDone/project6.png'

// styles
const styles = {
    imgWrapper: "hidden xl:grid xl:grid-cols-3 mt-8 h-full gap-x-5",
    imgWrapperMobile: "grid grid-cols-2 xl:hidden mt-8 h-full gap-x-5",
    imgContainer: 'flex flex-col items-center gap-5',
    imgStyle1: "w-full h-4/6 border rounded-lg hover:shadow-xl hover:border-secondary",
    imgStyle2: "w-full h-2/6 border rounded-lg hover:shadow-xl hover:border-secondary",
}

const index = () => {
  return (
    <div className="w-full">
    
        {/* Heading */}
        <div className="flex items-center md:justify-between">
            <HeadingPart heading={headingPart.HEADING_THINGS_WE_HAVE_MADE} text={headingPart.TEXT_THINGS_WE_HAVE_MADE} order_1={2} />
            <span className="hidden md:flex mr-8"><MoreArrow text={moreArrow.TEXT_VIEW_MORE} /></span>
        </div>

        {/* For Laptop and desktop */}
        <div className={styles.imgWrapper}>
            <div className={styles.imgContainer}>
                <img src={project1} alt="project1" className={styles.imgStyle1} />
                <img src={project4} alt="project4" className={styles.imgStyle2} />
            </div>

            <div className={styles.imgContainer}>
                <img src={project2} alt="project2" className={styles.imgStyle2} />
                <img src={project5} alt="project5" className={styles.imgStyle1} />
            </div>

            <div className={styles.imgContainer}>
                <img src={project3} alt="project3" className={styles.imgStyle1} />
                <img src={project6} alt="project6" className={styles.imgStyle2} />
            </div>
            
        </div>

        {/* For mobile and tablet */}
        <div className={styles.imgWrapperMobile}>
            <div className={styles.imgContainer}>
                <img src={project2} alt="project2" className={styles.imgStyle2} />
                <img src={project4} alt="project4" className={styles.imgStyle2} />
                <img src={project6} alt="project6" className={styles.imgStyle2} />
            </div>
            <div className={styles.imgContainer}>
                <img src={project1} alt="project1" className={styles.imgStyle1} />
                <img src={project5} alt="project5" className={styles.imgStyle1} />
                <img src={project3} alt="project3" className={styles.imgStyle1} />
                
            </div>
            
        </div>
    </div>
  )
}

export default index